enum ErrorTypes {
  NotificationCreate = "NotificationCreate",
}

export default ErrorTypes;
